import { Component, OnInit } from '@angular/core';
import { MessageService } from './../../services/message.service';
import { Subject } from 'rxjs/Subject';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';

@Component({
    selector: 'app-message-list',
    templateUrl: './message-list.component.html',
    styleUrls: ['./message-list.component.css']
})
export class MessageListComponent implements OnInit {
    loading$ = new Subject();
    keyWord = '';
    select: any = '0';
    listData;
    currentPage: Number = 1;
    pageSize: Number = 10;
    totalCount: Number = 0;
    show = false;

    constructor(
        private msgService: MessageService,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.update();
        this.route.queryParamMap.subscribe(x => {
            this.selectCategory('0');
        });
        this.msgService.updateCount();
    }



    selectCategory(index) {
        this.select = index;
        this.update();
    }

    handleItemDetail(item, i) {
        item.isShow = !item.isShow;
        if (item.delStatus !== '1') {
            item.delStatus = '1';
            this.msgService.markAsRead(item.id).subscribe(x => {
                // console.log(x);
            }, err => {
                item.delStatus = 0;
            });
        }
    }

    handlePageChange(event) {
        this.currentPage = event.currentPage;
        this.pageSize = event.pageSize;
        this.update();
    }

    update() {
        this.loading$.next(true);
        const postBody = {
            pageNumber: this.currentPage,
            pageSize: this.pageSize,
            status: this.select,
            keyword: this.keyWord
        };

        this.msgService.getMsgList(postBody)
            .toPromise()
            .then(res => {
                this.loading$.next(false);
                this.listData = res.list;
                this.totalCount = res.count;
            }, err => {
                this.loading$.next(false);
            });
    }

    onSearch(event) {
        this.update();
    }

    markAsReadAll() {
        this.msgService.markAsRead('').subscribe(x => {
            this.update();
        });
    }

    allFold() {
        // this.listData.forEach(function (item) {
        //     item.isShow = false;
        // });
        _(this.listData).forEach(function (item) {
            item.isShow = false;
        });
        this.show = false;
    }

    //  全部展开
    allUnfold() {
        _.each(this.listData, item => {
            item.isShow = true;
        });
        this.show = true;
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/message-list/message-list.component.ts